import { Stack, Typography, useTheme } from "@mui/material";
import type { Control } from "react-hook-form";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	CONTRACT_REQUIRED_MINIMUM_FIELDS,
	getContractRequiredMinimumMessage,
} from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import { PensionAdditionalFields } from "web_myplann/Portfolio/Forms/PensionForm/PensionAdditionalFields";
import { PensionBasicFields } from "web_myplann/Portfolio/Forms/PensionForm/PensionBasicFields";
import { PensionContractFields } from "web_myplann/Portfolio/Forms/PensionForm/PensionContractFields";
import type {
	PensionEditFormInput,
	PensionEditFormOutput,
} from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";
import { RequiredMinimumMessage } from "web_myplann/Portfolio/PortfolioShared/RequiredMinimumMessage";

type PensionEditFormFieldsProps = {
	control: Control<PensionEditFormInput, unknown, PensionEditFormOutput>;
	disableKeyFields?: boolean;
};

export const PensionEditFormFields = ({
	control,
	disableKeyFields,
}: PensionEditFormFieldsProps) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<>
			<PensionBasicFields
				control={control}
				disableKeyFields={disableKeyFields}
				namePlaceholder={t(
					Resources.Portfolio.AddPension.Placeholders.nameEdit,
				)}
				contractNumberPlaceholder={t(
					Resources.Portfolio.AddPension.Placeholders.contractNumberEdit,
				)}
			/>
			<RequiredMinimumMessage
				control={control}
				fields={CONTRACT_REQUIRED_MINIMUM_FIELDS}
				message={getContractRequiredMinimumMessage(
					t,
					Resources.Portfolio.AddPension.Fields,
				)}
			/>

			<Typography variant="sectionLabel">
				{t(Resources.Portfolio.AddPension.Sections.values)}
			</Typography>
			<Stack bgcolor={theme.palette.background.paper}>
				<PensionContractFields control={control} />
			</Stack>

			<PensionAdditionalFields
				control={control}
				disableKeyFields={disableKeyFields}
			/>
		</>
	);
};
